/* eslint-disable @typescript-eslint/no-shadow */

import rules from './rules'
import isEmpty from '../utils/isEmpty'

function isTemplateValidation(template) {
  return Array.isArray(template) && typeof template[0] === 'string'
}

function parseTemplateValidation(template, rules) {
  const [name, ...params] = template

  return rules[name](...params)
}

function wrapValidation(validate, isRequired = false) {
  return async function wrappedValidation(value) {
    const result = {
      validatedValue: value,
    }

    if (!isRequired && isEmpty(value)) {
      return result
    }

    const validationMessage = validate(value)

    if (!validationMessage) {
      return result
    }

    if (typeof validationMessage === 'string') {
      result.validationMessage = validationMessage

      throw result
    }

    if (validationMessage instanceof Promise) {
      try {
        result.ret = await validationMessage

        return result
      } catch (msg) {
        result.validationMessage = msg

        throw result
      }
    }

    return undefined
  }
}

export default function stdValidations({
  required, requiredMessage, type, validation, customMessages = {}, customRules = {},
}) {
  const validations = []
  const mergedRules = {
    ...rules,
    ...customRules,
  }

  if (required === true) {
    const requiredValidation = wrapValidation(rules.required(requiredMessage ?? customMessages.required), true)

    validations.push(requiredValidation)
  }

  if (typeof type === 'string' && type !== 'layout') {
    const customMsg = customMessages[type]
    const validate = rules[type](customMsg)
    const typeValidation = wrapValidation(validate)

    validations.push(typeValidation)
  }

  function addTemplateValidation(template) {
    const validate = parseTemplateValidation(template, mergedRules)
    const validation = wrapValidation(validate)

    validations.push(validation)
  }

  function addFunctionValidation(validate) {
    const validation = wrapValidation(validate)

    validations.push(validation)
  }

  if (validation !== undefined) {
    if (typeof validation === 'function') {
      addFunctionValidation(validation)
    } else if (isTemplateValidation(validation)) {
      addTemplateValidation(validation)
    } else {
      validation.forEach(item => {
        if (isTemplateValidation(item)) {
          addTemplateValidation(item)
        } else {
          addFunctionValidation(item)
        }
      })
    }
  }

  return validations
}
